import { SessionManager } from '@linqx/auth';
import type { FetchParams, Middleware, RequestContext, ResponseContext } from './generated/runtime';

export interface AuthMiddlewareOptions {
  getUserAgent?: () => string;
  onUnauthorized?: () => void;
}

export const createAuthMiddleware = (options: AuthMiddlewareOptions = {}): Middleware => {
  const { getUserAgent, onUnauthorized } = options;

  return {
    async pre(context: RequestContext): Promise<FetchParams | void> {
      const accessToken = SessionManager.getAccessToken();
      const headers: Record<string, string> = {
        ...(context.init.headers as Record<string, string>),
      };

      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      if (getUserAgent) {
        headers['User-Agent'] = getUserAgent();
      }

      return {
        url: context.url,
        init: {
          ...context.init,
          headers,
        },
      };
    },

    async post(context: ResponseContext): Promise<Response | void> {
      if (context.response.status === 401 && onUnauthorized) {
        onUnauthorized();
      }
      return context.response;
    },
  };
};
